var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPivotCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8,0 C12.418278,-8.11624501e-16 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 5.41083001e-16,12.418278 0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#F36E21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M5.288,12.4 C5.208,12.4 5.14,12.372 5.084,12.316 C5.028,12.26 5,12.192 5,12.112 L5,4.3 C5,4.212 5.028,4.14 5.084,4.084 C5.14,4.028 5.208,4 5.288,4 L8.504,4 C9.128,4 9.672,4.098 10.136,4.294 C10.6,4.49 10.96,4.786 11.216,5.182 C11.472,5.578 11.6,6.072 11.6,6.664 C11.6,7.264 11.472,7.758 11.216,8.146 C10.96,8.534 10.6,8.824 10.136,9.016 C9.672,9.208 9.128,9.304 8.504,9.304 L6.716,9.304 L6.716,12.112 C6.716,12.192 6.69,12.26 6.638,12.316 C6.586,12.372 6.516,12.4 6.428,12.4 L5.288,12.4 Z M6.692,7.972 L8.444,7.972 C8.908,7.972 9.264,7.862 9.512,7.642 C9.76,7.422 9.884,7.096 9.884,6.664 C9.884,6.264 9.768,5.942 9.536,5.698 C9.304,5.454 8.94,5.332 8.444,5.332 L6.692,5.332 L6.692,7.972 Z",
    mask: "url(#b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPivotCircle);
export default __webpack_public_path__ + "static/media/icon_pivot_circle.041840879c370fedb9fe6deefb8abe42.svg";
export { ForwardRef as ReactComponent };